import config from '../config';
import { BINGO_LICENSE, LEVIATHAN_LICENSE } from '../service/games';
import quantumIcon from '../assets/store/LeviathanQuantum.png';
import binglesIcon from '../assets/store/BingoBingles.png';
import duckatsIcon from '../assets/store/LeviathanDuckats.png';

import {
    BingoBinglesId,
    getUserInventory,
    LeviathanDuckatsId,
    LeviathanQuantumId,
    ProductDef,
    WrapperLicense,
} from '../service/inventory';

export const bingoCurrencyProductIDs = [
    'bingo_currency_bundle_1',
    'bingo_currency_bundle_2',
    'bingo_currency_bundle_3',
];
export const leviathanCurrencyProductIDs = [
    'leviathan_premium_bundle_1',
    'leviathan_premium_bundle_2',
    'leviathan_premium_bundle_3',
    'leviathan_premium_bundle_4',
    'leviathan_premium_bundle_5',
    'leviathan_premium_bundle_6',
];

export interface CurrencyDisplay {
    gameName: string;
    displayName: string;
    quantity: number;
    image: string;
}

export const getDisplayData = (itemId: string) => {
    switch (itemId) {
        case LeviathanDuckatsId:
            return { gameName: 'Leviathan', displayName: 'Duckats', image: duckatsIcon };
        case LeviathanQuantumId:
            return { gameName: 'Leviathan', displayName: 'Quantum Credits', image: quantumIcon };
        case BingoBinglesId:
            return { gameName: 'The Bingo Room', displayName: 'Bingles', image: binglesIcon };
    }

    return undefined;
};

export const purchaseProduct = async (
    product: ProductDef,
    token: string,
    userId: string,
): Promise<void> => {
    const resp = await fetch(`${config.inventoryServiceURL}/purchase`, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            license: WrapperLicense,
            product_id: product.product_id,
            user_id: userId,
        }),
        method: 'POST',
    });

    if (resp.status !== 200) {
        throw new Error('failed to purchase');
    }
};

export const fetchCurrencyBalances = async (
    token: string,
    userId: string,
): Promise<CurrencyDisplay[]> => {
    try {
        const invs = await getUserInventory(userId, 'currency', '', token);

        let outputList: CurrencyDisplay[] = [];
        invs.forEach((def) => {
            const displayData = getDisplayData(def.inventory_item.item_id);
            if (displayData) {
                outputList.push({
                    gameName: displayData.gameName,
                    displayName: displayData.displayName,
                    quantity: def.quantity,
                    image: displayData.image,
                });
            }
        });

        return outputList;
    } catch (err: any) {
        console.error(err);
    }

    return [];
};

export const getCurrencyForGame = (license: string): string => {
    switch (license) {
        case BINGO_LICENSE:
            return BingoBinglesId;
        case LEVIATHAN_LICENSE:
            return LeviathanQuantumId;
    }
    return '';
};
